import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEnhancementDataStart,
  setEnhancementDataSuccess,
  setEnhancementDataFailure,
  setSelectedFiles,
  // addUploadedDocumentUrl,
  // clearUploadedDocumentUrls,
  toggleEditMode,
  updateField,
  saveChanges,
  clearUploadedDocumentUrlsAfterSave,
  startSaving,
  finishSaving,
  setUploadedDocumentUrl,
  UploadDocument,
} from "../../models/EnhancementSlice";
import Enhancement from "../../components/patient/Enhancement/Enhancement";
import { AppDispatch, RootState } from "../..//store/store";
import {
  deleteUploadedDocument,
  downloadDocument,
  enhancementService,
} from "../../apis/patientService";
import FilePreviewModal from "../../components/patient/PreAuth-query/FilePreviewModal";
import { message, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  EnhancementCase,
  EnhancementField,
  EnhancementResponse,
} from "../../interfaces/IEnhancement";
import EnhancementList from "../../components/patient/Enhancement/EnhancementList";
import NewEnhancementModal from "../../components/patient/Enhancement/NewEnhancementModal";
import { IDocumentFields } from "../../interfaces/ICase";
import RightSidePreviewModal from "../../components/modals/RightSidePreviewModal";
import { IUploadReferral } from "../../interfaces/IReferral";
import DocumentDeficiencyModal from "../../components/patient/DocumentDeficiencyModal";
import { errorMessage, successMessage } from "../../utils/notificationUtils";
import {
  clearDeficiencyCheck,
  getDeficiencyQuestionData,
  getDeficiencyQuestions,
} from "../../models/patientSlice";
import Loader from "../../utils/Spinners";
import { errorMessageModal } from "../../utils/modalMessage";
interface EnhancementContainerProps {
  onfetchStepper: () => void; // Define prop type for the function
}
const EnhancementContainer: React.FC<EnhancementContainerProps> = ({
  onfetchStepper,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [portalMetaDataId, setPortalMetaDataId] = useState<number | null>(null);
  const [caseEnhancementId, setCaseEnhancementId] = useState<string | null>(
    null
  );
  const [selectedEnhancementIndex, setSelectedEnhancementIndex] = useState<
    number | null
  >(null);
  const [isNewEnhancementModalVisible, setIsNewEnhancementModalVisible] =
    useState(false);
  const [initialFormData, setInitialFormData] =
    useState<EnhancementCase | null>(null);
  // const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState<
  //   Array<IDocumentFields>
  // >([]);
  const [documentUrl, setDocumentUrl] = useState<string>("");
  const { patients, hospital, preAuth, auth } = useSelector(
    (state: RootState) => state
  );
  const [previewDocument, setPreviewDocument] = useState(false);
  const [selectedFile, setSelectedFile] = useState<IUploadReferral>({
    file: {},
    documentType: "",
  });
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState("");
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null
  ); //to send document id for deficiency check
  const [isFetchingEnhancementData, setIsFetchingEnhancementData] =
    useState<boolean>(false);
  const [documentName, setDocumentName] = useState("");
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [isDownloadingDocument, setIsDownloadingDocument] =
    useState<boolean>(false);
  const [downloadingDocumentUrl, setDownloadingDocumentUrl] =
    useState<string>("");
  const {
    activeStep,
    enhancementData,
    isLoading,
    error,
    editMode,
    editedFields,
    selectedFiles,
    uploadedDocumentUrl,
  } = useSelector((state: RootState) => state.enhancement);
  const getIds = useSelector((state: RootState) => state.patients);
  const [uploadFileModal, setUploadFileModal] = useState<boolean>(false);
  useEffect(() => {
    uploadedDocumentUrl?.forEach((doc) =>
      dispatch(
        updateField({
          sectionKey: "ihxEnhancementResponses",
          fieldId: doc?.documentLabelType?.split(" ").join("_"),
          value: doc?.documentUrl,
        })
      )
    );
  }, [uploadedDocumentUrl]);

  // useEffect(() => {
  //   dispatch(setUploadedDocumentUrl([]));
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedDocumentId) {
          dispatch(clearDeficiencyCheck());
          // const firstRes = await dispatch(
          //   getDeficiencyQuestions(selectedDocumentId)
          // );

          if (selectedDocument?.id) {
            const secondRes = await dispatch(
              getDeficiencyQuestionData(selectedDocument?.id)
            );
          }
        }
      } catch (err) {
        errorMessage("Please, Try again after sometime");
        setSelectedDocumentId(null);
        setSelectedDocument(null);
      }
    };

    if (selectedDocumentId || selectedDocument?.id) fetchData();
  }, [selectedDocumentId, selectedDocument?.id]);

  const handleDeficiencyModalOpen = (
    documentUrl: string,
    documentId: number,
    document: IDocumentFields
  ) => {
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDeficiencyModalAfterSave = (
    documentUrl: string,
    documentId: number,
    field: any
  ) => {
    const document = {
      id: field?.documentId,
      documentName: field?.documentName,
      documentType: field?.labelId,
      documentUrl: field?.data,
      documentLabelType: field?.label,
      deficiencyCheckStatus: field?.deficiencyCheckStatus,
    };
    setPreviewDocumentUrl(documentUrl);
    setSelectedDocumentId(documentId);
    setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocumentId(null);
    setSelectedDocument(null);
  };

  useEffect(() => {
    const fetchEnhancementData = async () => {
      dispatch(setEnhancementDataStart());

      try {
        if (getIds?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          const portalMetaData = await enhancementService.getPortalMetaData(
            getIds.fetchBasicDetails.casesResponse.schemeMetaDataId
          );
          if (
            portalMetaData.portalMetaDataIdsList &&
            portalMetaData.portalMetaDataIdsList.length > 0
          ) {
            setPortalMetaDataId(portalMetaData.portalMetaDataIdsList[0]);
          }
          setIsFetchingEnhancementData(true);
          const data = await enhancementService.getEnhancementData(
            getIds?.fetchBasicDetails?.casesResponse?.id,
            getIds?.fetchBasicDetails?.visitInfoResponse?.id,
            portalMetaData.portalMetaDataIdsList[0]
          );
          dispatch(setEnhancementDataSuccess(data));
          setIsFetchingEnhancementData(false);

          if (
            data.ihxEnhancementResponses &&
            data.ihxEnhancementResponses.length > 0
          ) {
            setSelectedEnhancementIndex(0);
            const caseEnhancementId =
              data.ihxEnhancementResponses[0]?.["Billing Details"]?.[0]
                ?.caseEnhancementId;
            if (caseEnhancementId) {
              setCaseEnhancementId(String(caseEnhancementId));
            }
            setInitialFormData(data.ihxEnhancementResponses[0]);
          }
        }
        // Fetch portal meta data
      } catch (error) {
        setIsFetchingEnhancementData(false);
        dispatch(
          setEnhancementDataFailure(
            error instanceof Error ? error.message : "An unknown error occurred"
          )
        );
      }
    };

    fetchEnhancementData();
  }, [
    dispatch,
    getIds?.fetchBasicDetails?.casesResponse?.id,
    getIds?.fetchBasicDetails?.visitInfoResponse?.id,
    getIds?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
  ]);

  const getAttachmentsWithValues = (enhancementData: EnhancementResponse) => {
    const attachmentsWithValues: Array<IDocumentFields> = [];

    if (enhancementData?.ihxEnhancementResponses) {
      const attachments = enhancementData?.ihxEnhancementResponses?.flatMap(
        (section: any) =>
          Object.values(section)
            ?.flat()
            ?.filter(
              (doc: any) =>
                doc?.type === "document-upload" || doc?.type === "document-show"
            )
      );
      attachments?.forEach((attachment: any) => {
        if (
          attachment?.documentsList &&
          attachment?.documentsList?.length > 0
        ) {
          attachment?.documentsList?.forEach((document: IDocumentFields) => {
            attachmentsWithValues.push({
              documentName: document?.documentName,
              documentType: document?.documentType,
              documentUrl: document?.documentUrl,
              id: document?.id,
              deficiencyCheckStatus: document?.deficiencyCheckStatus,
              documentLabelType: document?.documentLabelType,
            });
          });
        }
      });

      dispatch(setUploadedDocumentUrl(attachmentsWithValues));
    }
  };

  // useEffect(() => {
  //   if (enhancementData) {
  //     getAttachmentsWithValues(enhancementData);
  //   }
  // }, [enhancementData]);

  const viewFile = (file: any) => {
    window.open(file, "_blank");
  };

  const handleOpen = () => {
    setPreviewDocument(true);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      setDownloadingDocumentUrl(url);
      setIsDownloadingDocument(true);
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setDownloadingDocumentUrl("");
      setIsDownloadingDocument(false);
    }
  };

  const handleFileChange = (documentType: string) => (e: any) => {
    const maxSize = 15 * 1024 * 1024;
    if (Array.isArray(e)) {
      return e;
    }
    // if (e?.file?.size > maxSize) {
    //   errorMessage("File Limit must be less than or equal to 15 MB");
    //   return;
    // }

    if (e?.fileList[0]) {
      setSelectedFile({ file: e?.fileList[0], documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setUploadFileModal(true);
    }
    return e?.fileList;
  };

  const handleDeleteList = async (
    docType: string,
    documentUrl: string,
    i: number
  ) => {
    const deleteDocument = uploadedDocumentUrl?.find(
      (doc, index) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };
    const newUpdatedDocumentList = uploadedDocumentUrl?.filter(
      (doc, index) => doc?.documentUrl !== documentUrl
    );

    dispatch(setUploadedDocumentUrl(newUpdatedDocumentList));

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
      }
    }
    // if (enhancementData?.ihxEnhancementResponses) {
    //   const remainingDocsOfType = newUpdatedDocumentList?.filter(
    //     (doc) => doc.documentType === docType
    //   );
    //   if (remainingDocsOfType.length === 0) {
    //     dispatch(
    //       updateField({
    //         sectionKey: "ihxEnhancementResponses",
    //         fieldId: docType.split(" ").join("_"),
    //         value: "",
    //       })
    //     );
    //   }
    // }

    if (enhancementData?.ihxEnhancementResponses) {
      if (docType?.toUpperCase() === "OTHERS") {
        const hasDocument = newUpdatedDocumentList?.some(
          (doc) =>
            doc?.documentLabelType?.toUpperCase() === docType?.toUpperCase()
        );
        if (!hasDocument) {
          dispatch(
            updateField({
              sectionKey: "ihxEnhancementResponses",
              fieldId: docType?.split(" ").join("_"),
              value: "",
            })
          );
        }
      } else {
        dispatch(
          updateField({
            sectionKey: "ihxEnhancementResponses",
            fieldId: docType?.split(" ").join("_"),
            value: "",
          })
        );
      }
    }
  };

  const handleToggleEditMode = () => {
    if (!editMode && enhancementData) {
      const initialEditedFields: Record<string, Record<string, string>> = {};
      Object.keys(enhancementData)?.forEach((key) => {
        const sections = enhancementData[key as keyof EnhancementResponse] as
          | EnhancementCase[]
          | undefined;
        if (sections) {
          sections?.forEach((section) => {
            Object.entries(section)?.forEach(([sectionTitle, fields]) => {
              if (Array.isArray(fields)) {
                fields?.forEach((field: EnhancementField) => {
                  if (!initialEditedFields[key]) {
                    initialEditedFields[key] = {};
                  }
                  initialEditedFields[key][field.id] = field.data ?? "";
                });
              }
            });
          });
        }
      });
      dispatch(
        updateField({
          sectionKey: "all",
          fieldId: "all",
          value: initialEditedFields,
        })
      );
    }
    dispatch(toggleEditMode());
  };

  const handleSetDocumentUrl = (url: string) => {
    setDocumentUrl(url);
  };

  const handleFieldChange = (
    sectionKey: string,
    fieldId: string,
    value: string
  ) => {
    dispatch(updateField({ sectionKey, fieldId, value }));
  };

  const updateOrAddDocument = (
    uploadedDocumentUrl: Array<IDocumentFields>,
    documentRes: IDocumentFields
  ): Array<IDocumentFields> => {
    const updatedDocuments = [...uploadedDocumentUrl];
    const documentIndex = updatedDocuments?.findIndex(
      (doc) => doc.documentType === documentRes.documentType
    );

    if (
      documentIndex !== -1 &&
      documentRes?.documentLabelType?.toUpperCase() !== "OTHERS" &&
      !enhancementData?.ihxEnhancementResponses
    ) {
      updatedDocuments[documentIndex] = {
        ...updatedDocuments[documentIndex],
        documentName: documentRes?.documentName,
        documentUrl: documentRes?.documentUrl,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
        id: documentRes?.id,
        documentLabelType: documentRes?.documentLabelType,
      };
    } else {
      updatedDocuments.push({
        documentType: documentRes?.documentType,
        documentName: documentRes?.documentName,
        documentUrl: documentRes?.documentUrl,
        documentLabelType: documentRes?.documentLabelType,
        id: documentRes?.id,
        deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
      });
    }
    return updatedDocuments;
  };
  const handleCancel = () => {
    setUploadFileModal(false);
  };

  const handleUpload = async () => {
    // dispatch(clearUploadedDocumentUrls());
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString()
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id.toString()
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file?.originFileObj as Blob);
    }
    try {
      const resp = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        })
      ).unwrap(); // Use .unwrap() to get the actual payload

      // Now resp is the payload, not the action
      if (resp?.documentUrl) {
        message.success(`${resp?.documentLabelType} uploaded successfully`);
        const updatedDocuments = updateOrAddDocument(uploadedDocumentUrl, resp);
        dispatch(setUploadedDocumentUrl(updatedDocuments));
      } else {
        errorMessageModal("Please Upload Again");
      }
      setUploadFileModal(false);
    } catch (error) {
      console.error("Failed to upload document:", error);
      message.error("Failed to upload document. Please try again.");
    }
  };

  // await Promise.all(uploadPromises);
  // setPreviewModalVisible(false);

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const handleSaveChanges = async () => {
    try {
      dispatch(startSaving());
      const payload: any = {};

      if (
        enhancementData?.ihxEnhancementResponses &&
        selectedEnhancementIndex !== null
      ) {
        const currentEnhancement =
          enhancementData.ihxEnhancementResponses[selectedEnhancementIndex];

        // Add only pre-populated fields to the payload
        Object.entries(currentEnhancement)?.forEach(
          ([sectionKey, sectionData]) => {
            if (Array.isArray(sectionData)) {
              sectionData?.forEach((field: EnhancementField) => {
                if (field.data !== null && field.data !== "") {
                  payload[field.id] = field.data;
                }
              });
            }
          }
        );
      }

      // Add edited fields to the payload
      Object.entries(editedFields)?.forEach(([sectionKey, fields]) => {
        Object.entries(fields)?.forEach(([fieldId, value]) => {
          if (value !== null) {
            payload[fieldId] = value;
          }
        });
      });

      // Add document URLs
      if (uploadedDocumentUrl.length > 0) {
        payload.documentUrls = uploadedDocumentUrl;
      }

      if (portalMetaDataId === null) {
        throw new Error("Portal meta data ID is not available");
      }

      await enhancementService.saveEnhancementData(
        getIds?.fetchBasicDetails?.casesResponse?.id,
        getIds?.fetchBasicDetails?.visitInfoResponse?.id,
        portalMetaDataId,
        caseEnhancementId,
        payload
      );

      setIsNewEnhancementModalVisible(false);

      const newData = await enhancementService.getEnhancementData(
        getIds?.fetchBasicDetails?.casesResponse?.id,
        getIds?.fetchBasicDetails?.visitInfoResponse?.id,
        portalMetaDataId
      );
      onfetchStepper();
      dispatch(setEnhancementDataSuccess(newData));

      dispatch(saveChanges());
      // dispatch(clearUploadedDocumentUrlsAfterSave());
      dispatch(setUploadedDocumentUrl([]));

      message.success("Changes saved successfully");
    } catch (error) {
      console.error("Failed to save changes:", error);
      message.error("Failed to save changes. Please try again.");
    } finally {
      dispatch(finishSaving());
    }
  };

  const currentStageId = preAuth?.stepperData?.currentVisitStage?.visitStageId;
  const currentStep = preAuth?.currentStep;
  const visitStages = preAuth?.stepperData?.visitStages;
  const stepStageId = visitStages?.[currentStep]?.visitStageId;

  return (
    <div>
      {currentStageId && stepStageId && (currentStageId > stepStageId) ? (
        <></>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <Button
            icon={<PlusOutlined />}
            onClick={() => setIsNewEnhancementModalVisible(true)}
          >
            Add New Enhancement
          </Button>
        </div>
      )}

      {isFetchingEnhancementData ? (
        <Loader />
      ) : (
        <EnhancementList
          cases={enhancementData?.ihxEnhancementResponses || []}
          // onSelect={handleEnhancementSelect}
          selectedIndex={selectedEnhancementIndex}
          handleSetDocumentUrl={handleSetDocumentUrl}
          viewFile={viewFile}
          handleOpen={handleOpen}
          handleDownloadDocument={handleDownloadDocument}
          isDownloadingDocument={isDownloadingDocument}
          downloadingDocumentUrl={downloadingDocumentUrl}
          uploadedDocumentUrl={uploadedDocumentUrl}
          handleDeficiencyModal={handleDeficiencyModalOpen}
          closeDeficiencyModal={closeDeficiencyModal}
          deficiencyModal={deficiencyModal}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          previewDocumentUrl={previewDocumentUrl}
          setDocumentName={setDocumentName}
          handleDeficiencyModalAfterSave={handleDeficiencyModalAfterSave}
          handleDeleteList={handleDeleteList}
        />
      )}
      {selectedEnhancementIndex !== null &&
        enhancementData?.ihxEnhancementResponses &&
        (isFetchingEnhancementData ? (
          <Loader />
        ) : (
          <Enhancement
            activeStep={activeStep}
            handleFileChange={handleFileChange}
            enhancementData={
              enhancementData.ihxEnhancementResponses[selectedEnhancementIndex]
            }
            isLoading={isLoading}
            error={error}
            editMode={editMode}
            onToggleEditMode={handleToggleEditMode}
            onFieldChange={handleFieldChange}
            onSaveChanges={handleSaveChanges}
            editedFields={editedFields}
            handleDeficiencyModal={handleDeficiencyModalOpen}
            closeDeficiencyModal={closeDeficiencyModal}
            deficiencyModal={deficiencyModal}
            deficiencyQuestions={patients?.deficiencyCheckQuestions}
            previewDocumentUrl={previewDocumentUrl}
            setDocumentName={setDocumentName}
            handleDeficiencyModalAfterSave={handleDeficiencyModalAfterSave}
          />
        ))}
      <FilePreviewModal
        isVisible={uploadFileModal}
        onClose={handleCancel}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUpload}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.uid || "no-file"}
        isLoading={isLoading}
      />
      <NewEnhancementModal
        visible={isNewEnhancementModalVisible}
        uploadedDocumentUrl={uploadedDocumentUrl}
        handleDeleteList={handleDeleteList}
        handleSetDocumentUrl={handleSetDocumentUrl}
        viewFile={viewFile}
        handleOpen={handleOpen}
        onFieldChange={handleFieldChange}
        handleFileChange={handleFileChange}
        onCancel={() => setIsNewEnhancementModalVisible(false)}
        onSubmit={handleSaveChanges}
        fields={enhancementData?.ihxEnhancementResponses?.[0] || {}}
        initialData={initialFormData}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        previewDocumentUrl={previewDocumentUrl}
        setDocumentName={setDocumentName}
        handleDeficiencyModalAfterSave={handleDeficiencyModalAfterSave}
        patientDetails={patients?.fetchBasicDetails}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        downloadingDocumentUrl={downloadingDocumentUrl}
      />

      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={handleCancelPreview}
        open={previewDocument}
      />
      <DocumentDeficiencyModal
        key={previewDocumentUrl}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewDocumentUrl}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        isDownloadingDocument={isDownloadingDocument}
        downloadingDocumentUrl={downloadingDocumentUrl}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setUploadedDocumentUrl}
        type="enhancement"
      />
    </div>
  );
};

export default EnhancementContainer;
